import { IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Location } from "history";

/**
 * Parameters required to build Track Risks breadcrumb
 */
export interface TrackRisksBreadcrumbParams {
    customerTitle: string;
    appName: string;
    location: Location;
    history: any;
}

/**
 * Builds breadcrumb items for Track Risks app
 */
export const buildTrackRisksBreadcrumb = (
    params: TrackRisksBreadcrumbParams
): IBreadcrumbItem[] => {

    const {
        customerTitle,
        appName,
        location,
        history
    } = params;

    const items: IBreadcrumbItem[] = [];

    // --------------------------------------------------------
    // ROOT ITEMS
    // --------------------------------------------------------

    items.push({
        text: 'ZedX Apps',
        key: "root",
        onClick: () => history.push("/")
    });

    items.push({
        text: appName,
        key: "app",
        onClick: () => history.push("/a3/welcome")
    });

    // --------------------------------------------------------
    // DETERMINE CURRENT PATH
    // (supports BrowserRouter & HashRouter)
    // --------------------------------------------------------

    let path = location.pathname || "";
    if ((!path || path === "/") && location.hash) {
        path = location.hash
            .replace(/^#/, "")
            .split("?")[0]
            .split("#")[0];
    }

    // --------------------------------------------------------
    // ROUTE-SPECIFIC BREADCRUMB ITEMS
    // --------------------------------------------------------

    if (path === "/a3/welcome") {
        items.push({ text: "Welcome", key: "welcome", isCurrentItem: true });
    }
    else if (path === "/a3/insights") {
        items.push({ text: "Insights", key: "insights", isCurrentItem: true });
    }
    else if (path === "/a3/ai-chats") {
        items.push({ text: "Cloe AI Chats", key: "cloe-ai-chats", isCurrentItem: true });
    }
    else if (path.startsWith("/a3/ask-cloe")) {
        items.push({
            text: "Cloe AI Chats",
            key: "cloe-ai-chats",
            onClick: () => history.push('/a3/ai-chats')
        });
        items.push({ text: "Ask Cloe", key: "ask-cloe", isCurrentItem: true });
    }

    // ---------------- RISKS ----------------

    // ---------------- RISKS ----------------

    else if (path === "/a3/risks") {
        items.push({ text: "Risks", key: "risks", isCurrentItem: true });
    }
    else if (path.startsWith("/a3/risks-with-filters")) {
        items.push({ text: "Risks", key: "risks", isCurrentItem: true });
    }

    // ---------------- ISSUES ----------------

    else if (path === "/a3/issues") {
        items.push({ text: "Issues", key: "issues", isCurrentItem: true });
    }
    else if (path === "/a3/issues-actions") {
        items.push({
            text: "Issues",
            key: "issues",
            onClick: () => history.push("/a3/issues")
        });
        items.push({ text: "Actions", key: "issues-actions", isCurrentItem: true });
    }
    else if (path.startsWith("/a3/issues-actions-for-issue")) {
        items.push({
            text: "Issues",
            key: "issues",
            onClick: () => history.push("/a3/issues")
        });
        items.push({ text: "Actions", key: "issues-actions", isCurrentItem: true });
    }

    // ---------------- INCIDENTS ----------------

    else if (path === "/a3/incidents") {
        items.push({ text: "Incidents", key: "incidents", isCurrentItem: true });
    }
    else if (path === "/a3/incidents-actions") {
        items.push({
            text: "Incidents",
            key: "incidents",
            onClick: () => history.push("/a3/incidents")
        });
        items.push({ text: "Actions", key: "incidents-actions", isCurrentItem: true });
    }
    else if (path.startsWith("/a3/incidents-actions-for-incident")) {
        items.push({
            text: "Incidents",
            key: "incidents",
            onClick: () => history.push("/a3/incidents")
        });
        items.push({ text: "Actions", key: "incidents-actions", isCurrentItem: true });
    }

    // ---------------- RISK MITIGATION ----------------

    else if (path === "/a3/risk-mitigating-actions") {
        items.push({ text: "Risk Mitigation Actions", key: "risk-mitigations", isCurrentItem: true });
    }
    else if (path.startsWith("/a3/risk-mitigating-actions-for-risk")) {
        items.push({
            text: "Risk Mitigation Actions",
            key: "risk-mitigations",
            isCurrentItem: true
        });
    }

    // ---------------- RISK SIGN-OFF ----------------

    else if (path.startsWith("/a3/sign-off-for-risk")) {
        items.push({
            text: "Risks",
            key: "risks",
            onClick: () => history.push("/a3/risks")
        });
        items.push({ text: "Sign Off", key: "risk-signoff", isCurrentItem: true });
    }

    // ---------------- SETTINGS ----------------

    else if (path === "/a3/settings/customFields") {
        items.push({ text: "Settings", key: "settings", isCurrentItem: true });
        items.push({ text: "Custom Fields", key: "custom-fields", isCurrentItem: true });
    }
    else if (path === "/a3/settings/risk-types") {
        items.push({ text: "Settings", key: "settings", isCurrentItem: true });
        items.push({ text: "Risk Types", key: "risk-types", isCurrentItem: true });
    }

    // ---------------- OUTPUTS ----------------

    else if (path.startsWith("/a3/outputs")) {
        items.push({ text: "Outputs", key: "outputs", isCurrentItem: true });
    }

    return items;
};
